import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { merge } from 'lodash-es';
import { ApiResponse } from '../../../../classes/api-response';
import { UsersService } from '../../../../services/users.service';
import { SnackService } from '../../../../services/snack.service';
import { Customer } from "../../../../model/customer";
import { CompaniesService } from "../../../../services/companies.service";
import { Company } from "../../../../model/company";
import { Constants } from "../../../../utils/constants";
import { AuthService } from "../../../../services/auth.service";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'aw-customer-form',
  templateUrl: './customer-form.component.html',
  styleUrls: ['./customer-form.component.scss']
})
export class CustomerFormComponent implements OnInit {

  userForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  loadingCompanies = false;
  saving = false;
  isEditing = false;
  generalError?: ApiResponse;

  companies: Company[] = [];
  loggedUser: any;
  selectedCompany: Company | undefined = new Company();
  roles = Constants.roles;
  previousUrl: string = '';

  constructor(
    private userService: UsersService,
    private authService: AuthService,
    private snackService: SnackService,
    private companiesService: CompaniesService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    if (route.snapshot.url[0])
      this.previousUrl = route.snapshot.url[0].path;
    this.userForm = new UntypedFormGroup(
      {
        email: new UntypedFormControl(
          '',
          [
            Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"),
            Validators.required
          ]
        ),
        firstName: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.pattern('^(?!\\.)(?!.*\\.$)(?!.*?\\.\\.)(?![\\s.]+$)[a-zA-Z\\s.]*$')

          ]
        ),
        lastName: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.pattern('^(?!\\.)(?!.*\\.$)(?!.*?\\.\\.)(?![\\s.]+$)[a-zA-Z\\s.]*$')
          ]
        ),
        phone: new UntypedFormControl(
          '',
          [
            Validators.pattern('[- +()0-9]+'),
            Validators.required
          ]
        ),
        company: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        )
      },
    );


  }

  _customer = new Customer();

  @Input() set customer(value: Customer) {
    this._customer = merge(new Customer(), value);
    this.selectedCompany = value?.company;
    this.isEditing = !!value?.id;
    this.userForm.patchValue(this._customer);
    if (value.id) {
      this.userForm.controls.email.disable();
    }
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();

    this.loadingCompanies = true;

    if (this.loggedUser.role !== this.roles.customer && !this.isEditing) {
      this.companiesService.getAllCompanies().subscribe(companies => {
        this.companies = companies;
        this.loadingCompanies = false;
      });
    }
  }

  saveUser(): void {

    this.saving = true;

    const newUser = merge(new Customer(), this._customer, this.userForm.value);

    this.generalError = undefined;

    if (this._customer.id) {
      // delete newUser.company;
      this.userService.updateCustomer(newUser)
        .subscribe(
          () => {
            this.saving = false;
            this.customer = newUser;
            this.snackService.success('Customer updated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    } else {
      this.userService.createCustomer(newUser)
        .subscribe(
          () => {
            this.saving = false;
            this.customer = newUser;
            this.snackService.success('Customer created!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }

  }

  onCancel():void {

    if(this.previousUrl === 'edit')
      this.router.navigateByUrl("/reserved/profile")
    this.customer = this._customer;
    this.canceled.emit();

  }


}
